import styled from 'styled-components';

import { ActiveStateOrUSId } from '../../types';
import PolicySelect from './PolicySelect';
import StateSelect from './StateSelect';
import YearSelect from './YearSelect';

const Container = styled.div`
	background-color: #f5f5f5;
	border: 1px solid #aaa;
	border-radius: 4px;
	display: grid;
	font-family: 'Lato', sans-serif;
	font-size: 1rem;
	grid-gap: 1rem;
	grid-template-areas:
		'years'
		'states'
		'policies';
	justify-items: stretch;
	padding: 1rem;
	margin-bottom: 1rem;

	@media (min-width: 600px) {
		grid-template-columns: repeat(2, 1fr);
		grid-template-areas:
			'years states'
			'policies policies';
	}
`;

interface Props {
	activeState: ActiveStateOrUSId;
	setActiveState: (stateId: ActiveStateOrUSId) => void;
	year: number;
	setYear: (year: number) => void;
	startYear: number;
	endYear: number;
}

const Navigation = ({
	activeState,
	setActiveState,
	year,
	setYear,
	startYear,
	endYear,
}: Props) => {
	return (
		<Container>
			<YearSelect
				area="years"
				year={year}
				setYear={setYear}
				startYear={startYear}
				endYear={endYear}
			/>
			<StateSelect
				area="states"
				activeState={activeState}
				setActiveState={setActiveState}
			/>
			<PolicySelect area="policies" />
		</Container>
	);
};

export default Navigation;
